import{create_ssr_component as r}from"svelte/internal";const $=r((s,t,e,o)=>"");export{$ as default};
//# sourceMappingURL=Index13.js.map
